import { put } from './requests'

const resourcePath = 'hooks'

export function enableHook (id) {
  return put(`${resourcePath}/${id}/enable`)
}
